import { PropsWithChildren } from "react";
import { Layout } from "antd";
const { Content } = Layout;

const NoPermissionTemplate = (props: PropsWithChildren) => {
  return (
    <Layout>
      <Layout className="main_layout">
        <Content className="content_area">{props.children}</Content>
      </Layout>
    </Layout>
  );
};

export default NoPermissionTemplate;
